'use client';
import {
    ContactCardAddressItem,
    ContactCardEmailItem,
    ContactCardInstitutionItem,
    ContactCardLinkItem,
    ContactCardPhoneItem
} from '..';
import { TitleLarge } from '../../styles';
import { Institution } from '../../types/Institution';
import { ContactInfoContainer } from './styles';
import { useTranslations } from 'next-intl';

type Props = {
    institution: Institution;
};
export const ContactInfoInstitution = ({ institution }: Props) => {
    const t = useTranslations('general');
    const { type, name, website, address, email, phone } = institution;

    return (
        <ContactInfoContainer>
            <TitleLarge>{t(type)}</TitleLarge>
            <ContactCardInstitutionItem type={type} name={name} />
            {email && <ContactCardEmailItem email={email} />}
            {phone && <ContactCardPhoneItem phoneNumber={phone.toString()} />}
            {website && <ContactCardLinkItem link={website} />}
            <ContactCardAddressItem address={address.fullAddress} />
        </ContactInfoContainer>
    );
};
